
export default {
    entryUrl: null,
    openid:null,
    unionid:null
}



// WEBPACK FOOTER //
// ./src/components/global.vue